import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$orgSlug/admin/events")({
  // Component moved to $orgSlug.admin.events.lazy.tsx for code splitting
});
